module.exports = __webpack_public_path__ + "static/media/portakabin-logo-charcoal.bd97b862.svg";